module.exports = __webpack_public_path__ + "static/media/Uplands Road N8 (2).98e979f1.JPG";